import React, { ReactElement } from 'react'
import { Flex, Text } from 'theme-ui'
import ConfigurationCode from './ConfigurationCode'
import { Svg } from 'ui'
import NetshInterfaceImage from 'images/helpPaneSteps/windows/win-netsh-interface.svg'

export default function WindowsInterfaceConfiguration({ ip }: { ip: string }): ReactElement {
  return (
    <Flex
      sx={{
        width: '100%',
        maxWidth: '37.7rem',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        px: ['1.6rem', 0],
        textAlign: 'center',
        pb: '1.8rem',
        gap: '4rem',
        color: 'aliceBlue',
      }}
    >
      <Text variant="size14Weight400Line138">
        Find the Interface you are currently using or want to change the DNS server on. The one
        you&apos;re most likely looking for will be called “Ethernet” or “Wi-fi”. To know for sure,
        run this command.
      </Text>
      <ConfigurationCode text="netsh interface show interface" />
      <Text variant="size14Weight400Line138">You should see something similar to this:</Text>
      <Svg
        svg={NetshInterfaceImage}
        sx={{ width: ['29rem', '37.7rem'], height: 'fit-content' }}
        descriptiveText="Windows netsh interface command output"
      />
      <Text variant="size14Weight400Line138">
        Choose the &quot;Interface Name&quot; that is both Enabled and Connected. In the above
        example it&apos;s &quot;Ethernet&quot;. Now run this command.
      </Text>
      <ConfigurationCode text={`netsh interface ipv4 set dns name="Ethernet" static ${ip}`} />
    </Flex>
  )
}
